class HeaderComponent extends HTMLElement {
  connectedCallback() {
    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleOutsideClick = this.handleOutsideClick.bind(this);
    this.handleEscKey = this.handleEscKey.bind(this);
    this.handleMenuLinkClick = this.handleMenuLinkClick.bind(this);
    this.burgerMenu = this.querySelector('.header-nav__menu');
    this.menuPanel = this.querySelector('.menu-panel');
    this.header = this.querySelector('.header');

    if (this.burgerMenu) {
      this.burgerMenu.addEventListener('click', (e) => {
        e.preventDefault();
        this.toggleMenu();
      });
    }

    document.addEventListener('click', this.handleOutsideClick);
    document.addEventListener('keydown', this.handleEscKey);

    const menuLinks = this.querySelectorAll('.menu-panel__link, .menu-panel__button');
    menuLinks.forEach((link) => {
      link.addEventListener('click', this.handleMenuLinkClick);
    });

    if (this.header) {
      const headerHeight = this.header.offsetHeight;
      window.addEventListener('scroll', () => {
        if (window.scrollY > headerHeight) {
          this.header.classList.add('sticky');
        } else {
          this.header.classList.remove('sticky');
        }
      });
    }
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleOutsideClick);
    document.removeEventListener('keydown', this.handleEscKey);

    const menuLinks = this.querySelectorAll('.menu-panel__link, .menu-panel__button');
    menuLinks.forEach((link) => {
      link.removeEventListener('click', this.handleMenuLinkClick);
    });
  }

  toggleMenu() {
    const isCurrentlyActive = this.menuPanel.classList.contains('active');
    const isMobile = window.innerWidth <= 767;

    if (!isCurrentlyActive) {
      this.burgerMenu.classList.add('active');
      this.menuPanel.classList.add('active');
      this.overlay = document.createElement('div');
      this.overlay.className = 'menu-overlay';
      this.overlay.addEventListener('click', this.handleOutsideClick);
      document.body.appendChild(this.overlay);

      if (isMobile) {
        document.body.classList.add('menu-open');
      }
    } else {
      this.burgerMenu.classList.remove('active');

      if (this.overlay) {
        this.overlay.removeEventListener('click', this.handleOutsideClick);
        document.body.removeChild(this.overlay);
        this.overlay = null;
      }

      if (isMobile) {
        document.body.classList.remove('menu-open');
        setTimeout(() => {
          this.menuPanel.classList.remove('active');
        }, 10);
      } else {
        this.menuPanel.classList.remove('active');
      }
    }
  }

  handleOutsideClick(e) {
    if (
      this.menuPanel.classList.contains('active') &&
      !this.menuPanel.contains(e.target) &&
      e.target !== this.burgerMenu &&
      !this.burgerMenu.contains(e.target)
    ) {
      this.toggleMenu();
    }
  }

  handleEscKey(e) {
    if (e.key === 'Escape' && this.menuPanel.classList.contains('active')) {
      this.toggleMenu();
    }
  }

  handleMenuLinkClick() {
    this.toggleMenu();
  }
}

customElements.define('header-component', HeaderComponent);
